import { makeStyles } from '@material-ui/core/styles'
import { IStyleProps } from './Interface'

export default makeStyles<{}, IStyleProps>({
  root: {
    width: 210,
    marginRight: -40
  },
  gridContainer: {
    background: '#7647B2',
    padding: '30px 0',
    borderRadius: 12,
    boxShadow: '0 0 10px 3px rgba(0,0,0,.1)',
    left: ({ publicMode }) => (publicMode ? 'calc(100vw / 2 - 550px)' : 0),
    position: ({ publicMode }) => (publicMode ? 'fixed' : 'absolute'),
    top: '25%',
    width: 230,
    '& > ul': {
      listStyle: 'none',
      paddingInlineStart: 0
    }
  },
  isSelected: {
    background: 'rgba(255,255,255,.3) !important'
  },
  menuItem: {
    position: 'relative',
    padding: '7px 30px',
    transition: '.2s',
    background: 'rgba(255,255,255,0)',
    textDecoration: 'none',
    '&:hover': {
      background: 'rgba(255,255,255,.3)',
      transition: '.2s',
      cursor: 'pointer'
    }
  },
  menuItemText: {
    color: 'white',
    fontSize: 14,
    textDecoration: 'none'
  }
})
